// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum OperationType {
  unknown0 = 0,
  floor_call = 1,
  carcall = 2,
  alloc_cc = 3,
  secure_cc = 4,
  lock_cabin_call = 5,
  group_status = 6,
  status = 7,
  drive_status = 8,
  direction = 9,
  position = 10,
  load = 11,
  door = 12,
  final_timer = 13,
  bypassed_floor = 14,
}
